import { classnames } from '@aibees/shared/utils';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { StackedColumnChartProps as Props } from './types';

export const StackedColumnChart = memo(({ className, options }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('StackedColumnChart', className)}
      sx={SX.root}
    >
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Styled.Wrapper>
  );
});

StackedColumnChart.displayName = 'StackedColumnChart';
